import { render, staticRenderFns } from "./StoryblokImage.vue?vue&type=template&id=95751af4&"
import script from "./StoryblokImage.vue?vue&type=script&lang=js&"
export * from "./StoryblokImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports